var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 44,
    rx: 6,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 19.5625C33.5 26.125 23.7697 31.4369 23.3553 31.6562C23.2461 31.715 23.124 31.7458 23 31.7458C22.876 31.7458 22.7539 31.715 22.6447 31.6562C22.2303 31.4369 12.5 26.125 12.5 19.5625C12.5017 18.0215 13.1147 16.544 14.2044 15.4544C15.294 14.3647 16.7715 13.7517 18.3125 13.75C20.2484 13.75 21.9434 14.5825 23 15.9897C24.0566 14.5825 25.7516 13.75 27.6875 13.75C29.2285 13.7517 30.706 14.3647 31.7956 15.4544C32.8853 16.544 33.4983 18.0215 33.5 19.5625Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartImg);
export default __webpack_public_path__ + "static/media/heartImg.5cbfd04d918cefd3372791365376fd40.svg";
export { ForwardRef as ReactComponent };